exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media only screen and (max-width: 600px) and (orientation: portrait) {\n  .MuiDialog-paperWidthLg.MuiDialog-paperScrollBody {\n    max-width: none;\n    max-height: none; } }\n", ""]);
